import { useNavigate } from 'react-router';

import { useTranslation } from 'react-i18next';
import { Button } from '../UI';
import { useMutation } from '@apollo/client';
import { SET_PROFILE_COMPLETED } from '../../http/apollo-queries';
import { useAuth } from '../../context/Auth';
import { useState } from 'react';
import { Modal } from '../Modal';

const RegistrationCompleted = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const { user, refetch: refetchUser } = useAuth();
  const [setProfileCompleted] = useMutation(SET_PROFILE_COMPLETED, {
    variables: { profileId: user?.profile?.id },
  });

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'huge'}
    >
      <>
        <div className={'flex flex-col items-center justify-center h-32'}>
          <img src={`icons/whoho.svg`} />
        </div>
        <h1 className="text-black text-xl font-semibold text-center mt-8">
          {t('registrationCompleted.title')}
        </h1>
        <p className="mt-4 text-grey-50 text-sm max-w-xs text-center">
          {t('registrationCompleted.description')}
        </p>
        <div className="mt-12 flex justify-center w-full px-6 items-center">
          <Button
            loading={loading}
            type="button"
            variant="primary"
            onClick={() => {
              setLoading(true);
              // navigate('/actual'); 07-06-'22
              setProfileCompleted()
                .then(() => refetchUser())
                .then(() => navigate('/strategies'))
                .finally(() => setLoading(false));
            }}
          >
            {t('onBoarding.continue')}
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default RegistrationCompleted;
